/* eslint-disable no-useless-escape */
import * as Yup from 'yup';
import moment from 'moment';
import {
  isDefine,
  filterDuplicateItem,
  hasDuplicateItem,
  trimListString,
  isNumeric,
} from 'helpers';
import { stateOffer } from './data';
import { smsCounter } from 'helpers/SmsCharacter';
import { checkLimitDecimal } from 'helpers/string';
import { get, isArray, isInteger, isString } from 'lodash';
import {
  INCORRECT_FORMAT,
  MUST_BE_NUMBER,
  REQUIRED_FIELD,
  MUST_BE_LARGER_OR_EQUAL_THAN,
  MUST_BE_INTEGER_NUMBER,
} from './message';

export const listDelimiter = [',', ';', '\n'];

const maxLengthName = 20;
export const onlyNumber = /^[0-9]*$/;
const validEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const phoneRegExp =
  /^[\+]((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const validDomain =
  /(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]/;
const onlyLettersAndNumber = /^[a-zA-Z0-9_.-]*$/;
const validMessageVariableRegExp = /\[.*\]/;
const validNotSpecialCharacter = /^[a-zA-Z0-9\_ \-]*$/;
const IpRegExp =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
const minContactToOptimization = 99;

const minPausedMinOptimization = 10;
const maxPausedMinOptimization = 2400;

const commonInputMaxLength = 255;

export const onlyNumberRegExp = /^[0-9]+$/;
export const OnlyNumberWithNegativeRegex = /^[-]?[0-9]+$/;

//! Helper validate
export const checkIsValidIP = (ip) => {
  if (isString(ip) && IpRegExp.test(ip?.trim() || '')) {
    return true;
  }

  return false;
};

export const validationFiltersInbox = Yup.object().shape({
  errors: Yup.array().test('required', 'Select at least one error!', function () {
    const { parent } = this;
    const errors = parent?.errors || [];

    const isErrorSelected = parent?.filterBy?.some((el) => el.value === 'filterError');
    if (isErrorSelected && errors.length <= 0) {
      return false;
    }

    return true;
  }),
});

// helper for yup transform function
export const testSchema = {
  isRequired: (field) => {
    return function () {
      const { parent } = this;
      const value = get(parent, field);

      if (!isDefine(value)) {
        return false;
      }

      return true;
    };
  },

  mustBeIntegerNumber: (field) => {
    return function () {
      const { parent } = this;
      const value = get(parent, field);
      if (!isNumeric(value)) {
        return false;
      }

      if (!isInteger(Number(value))) {
        return false;
      }

      return true;
    };
  },
  mustGreaterThanZero: (field) => {
    return function () {
      const { parent } = this;
      const value = get(parent, field);

      if (isNumeric(value) && value <= 0) {
        return false;
      }

      return true;
    };
  },

  isValidIP: (field) => {
    return function () {
      const { parent } = this;
      const value = get(parent, field);

      if (!checkIsValidIP(value)) {
        return false;
      }

      return true;
    };
  },
};

export const validateTrimAndRequiredString = (field, { isObject = false } = {}) => {
  if (isObject) {
    return Yup.mixed().test('required', REQUIRED_FIELD(field), function (obj) {
      if (!obj || !isDefine(obj.value)) {
        return false;
      }

      return true;
    });
  }

  return Yup.string().trim().required(REQUIRED_FIELD(field));
};

const emptyStringToNull = (value, originalValue) => {
  if (typeof originalValue === 'string' && originalValue === '') {
    return null;
  }
  return value;
};

const checkAllDelimiterAppearTogether = (listDelimiter, domains) => {
  let listDelimiterAppear = listDelimiter.reduce((arr, el) => {
    if (domains.includes(el)) {
      arr = [...arr, el];
    }
    return arr;
  }, []);

  return listDelimiterAppear.length > 1;
};

export const checkIsValidDomain = (val = '') => {
  if (isString(val) && validDomain.test(val?.trim() || '')) {
    return true;
  }
  return false;
};

export const isOnlyNumber = (val = '') => {
  return onlyNumber.test(val);
};

//! Validate
// const LENGTH_OF_SIM = 19;
export const validationSIMBarcode = Yup.object().shape({
  sim: Yup.string()
    .trim()
    .required(REQUIRED_FIELD('SIM'))
    .matches(onlyNumberRegExp, 'SIM must be only digits'),
  // .min(LENGTH_OF_SIM, MUST_BE_EQUAL_OR_LARGER_THAN('SIM', LENGTH_OF_SIM))
  // .max(LENGTH_OF_SIM, MUST_BE_SMALLER_OR_EQUAL_THAN('SIM', LENGTH_OF_SIM)),
});

export const validationAddSIMOrderSchema = Yup.object().shape({
  simList: Yup.array().of(validationSIMBarcode),
});

const emailYupCheck = Yup.string()
  .test('EmailValidateCustom', 'Email is invalid', function () {
    const { email } = this.parent;
    if (email && email.trim()) {
      if (/\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/g.test(email.trim())) {
        return true;
      }
    }
    return false;
  })
  .required('Email is required');

const passwordYupCheck = Yup.string()
  .trim('Password is required')
  .required('Password is required')
  .min(8, 'Password is invalid')
  .max(30, 'Password is invalid');

export const dateRangesYup = ({ isDateRequired } = { isDateRequired: false }) =>
  Yup.object().shape(
    {
      from: Yup.date()
        .when(['to'], {
          is: (to) => !!to,
          then: Yup.date().required(REQUIRED_FIELD('From')),
        })
        .nullable()
        .test('required-date', REQUIRED_FIELD('From'), function () {
          const { from } = this.parent;
          if (isDateRequired) {
            if (!from) {
              return false;
            }
          }
          return true;
        }),
      to: Yup.date()
        .when(['from'], {
          is: (from) => !!from,
          then: Yup.date().required(REQUIRED_FIELD('To')),
        })
        .nullable()
        .test('required-date', REQUIRED_FIELD('To'), function () {
          const { to } = this.parent;
          if (isDateRequired) {
            if (!to) {
              return false;
            }
          }
          return true;
        }),
    },
    ['from', 'to'],
  );

export const validateDateRanges = Yup.object().shape({
  dateRanges: dateRangesYup(),
});

export const validationLogin = Yup.object().shape({
  email: emailYupCheck,
  password: passwordYupCheck,
});

export const validationLoginWithOTP = Yup.object().shape({
  email: emailYupCheck,
  password: passwordYupCheck,
  otp: Yup.string().trim('OTP is required').required('OTP is required').length(6, 'OTP is invalid'),
});

export const validationForgotPassword = Yup.object().shape({
  email: emailYupCheck,
});

export const validationResetPassword = Yup.object().shape({
  password: passwordYupCheck,
  passwordConfirm: passwordYupCheck,
});

export const validationDateRangeFinance = Yup.object().shape({
  dateRanges: Yup.object().shape({
    from: Yup.string().required(REQUIRED_FIELD('From')),
    to: Yup.string().required(REQUIRED_FIELD('To')),
  }),
});

export const validateMCCMNCMapping = Yup.object().shape({
  note: validateTrimAndRequiredString('Note'),
  country: validateTrimAndRequiredString('Country'),
  // mcc: validateTrimAndRequiredString('MCC'),
  // mnc: validateTrimAndRequiredString('MNC'),
  carrier: Yup.mixed().test(
    'required',
    REQUIRED_FIELD('Carrier'),
    testSchema.isRequired('carrier'),
  ),
});

//* For text mode
export const validationListKeyValue = Yup.array().of(
  Yup.object().shape({
    key: Yup.string().required(REQUIRED_FIELD('Key')),
    value: Yup.string()
      .required(REQUIRED_FIELD('Value'))

      .test('checkValue', 'Value is required field!', function () {
        const value = this?.parent?.value;
        if (!value) {
          return false;
        }

        return true;
      })
      .test('check IP', INCORRECT_FORMAT('Value'), function () {
        const { key, value } = this.parent;

        //* Validate if Key = IP
        if (key === 'ip') {
          const ips = value?.split(',').map((el) => el.trim());
          let errorFound = false;

          for (let ip of ips) {
            if (!checkIsValidIP(ip)) {
              errorFound = true;
              break;
            }
          }

          if (errorFound) {
            return this.createError({
              path: this.path,
              message: INCORRECT_FORMAT('Value'),
            });
          }
        }

        //* Validate if value is accept only Number
        if (key === 'ipMaxClick') {
          if (!isOnlyNumber(value)) {
            return this.createError({
              path: this.path,
              message: MUST_BE_NUMBER('Value'),
            });
          }
        }
        if (key === 'expireTime') {
          if (!isOnlyNumber(value)) {
            return this.createError({
              path: this.path,
              message: MUST_BE_NUMBER('Value'),
            });
          }
        }
        if (key === 'shortLinkMaxClick') {
          if (!isOnlyNumber(value)) {
            return this.createError({
              path: this.path,
              message: MUST_BE_NUMBER('Value'),
            });
          }
        }

        if (key === 'MaxRiskScore' || key === 'maxRiskScore') {
          if (isNumeric(value) && Number(value) < 0) {
            return this.createError({
              path: this.path,
              message: MUST_BE_LARGER_OR_EQUAL_THAN('Value', 0),
            });
          }

          if (isNumeric(value) && !Number.isInteger(Number(value))) {
            return this.createError({
              path: this.path,
              message: MUST_BE_INTEGER_NUMBER('Value'),
            });
          }

          if (!isOnlyNumber(value)) {
            return this.createError({
              path: this.path,
              message: MUST_BE_NUMBER('Value'),
            });
          }
        }

        return true;
      }),
  }),
);

export const validationClickRequestSchema = Yup.object().shape({
  skipIpList: Yup.string()
    .test('Test Ip List', 'Ip is incorrect format, please check again before update', function () {
      const { skipIpList } = this.parent;
      if (skipIpList && isString(skipIpList)) {
        const value = skipIpList.trim();
        //* value: 192.168.1.0, 192.168.3.2

        const listValSplitted = value.split(',');
        //* listValSplitted: [192.168.1.0, 192.168.3.2];

        if (isArray(listValSplitted)) {
          for (let val of listValSplitted) {
            if (!IpRegExp.test(val.trim())) {
              return false;
            }
          }
        }
      }

      return true;
    })
    .trim('IP is required field!')
    .required('IP is required field!'),
});

export const validationIP = Yup.object().shape({
  ip: Yup.string()
    .trim('IP is required field!')
    .required('IP is required field!')
    .matches(IpRegExp, 'IP is incorrect format!'),
});

export const validationUserAgent = Yup.object().shape({
  userAgent: Yup.string()
    .trim('User agent is required field!')
    .required('User agent is required field!'),
});

export const validationCreateTicket = Yup.object().shape({
  title: Yup.string().trim('Title is required field!').required('Title is required field!'),
});

export const validationFormCreative = Yup.object().shape({
  title: Yup.string().trim('Title is required field!').required('Title is required field!'),
  message: Yup.string()
    .required('Message field is required!')
    .max(9000, 'Message is too long, need to less than 9000 characters!'),
});

export const validationChangeNameMenu = Yup.object().shape({
  title: Yup.string().trim('Title is required field!').required('Title is required field!'),
});

export const validationInboxSend = Yup.object().shape({
  message: Yup.string()
    .trim('Message is required field!')
    .required('Message is required field!')
    .test('checkTotalSMS', 'Length of message must be in 1 SMS!', function () {
      const { parent } = this;
      const { message } = parent;
      if (message && typeof message === 'string' && smsCounter(message.trim()).smsCount > 1) {
        return false;
      }

      return true;
    }),
});

export const validationAllowSend = Yup.object().shape({
  campaignCheck: Yup.boolean(),
  deliveredThreshold: Yup.number()
    .typeError('Threshold must be integer number!')
    .integer('Threshold must be integer number!')
    .min(0, 'Threshold must be in range 0 <= number <= 99')
    .max(99, 'Threshold must be in range 0 <= number <= 99')
    .required('Threshold is required field!'),
});

export const validationAllowRelease = Yup.object().shape({
  autoRelease: Yup.boolean(),
  deliveredThresholdRelease: Yup.number()
    .typeError('Threshold must be integer number!')
    .integer('Threshold must be integer number!')
    .min(0, 'Threshold must be in range 0 <= number <= 99')
    .max(99, 'Threshold must be in range 0 <= number <= 99')
    .required('Threshold is required field!'),
});

export const validationCallForward = Yup.object().shape({
  forwardPhone: Yup.string()
    .typeError('Must be a phone number')
    .matches(phoneRegExp, 'Must be a phone number'),
});

export const validationReleaseDid = Yup.object().shape({
  autoRelease: Yup.boolean(),
  deliveredThresholdRelease: Yup.number()
    .typeError('Threshold must be integer number!')
    .integer('Threshold release must be integer number!')
    .min(0, 'Threshold release must be in range 0 <= number <= 99')
    .max(99, 'Threshold release must be in range 0 <= number <= 99')
    .required('Threshold release is required field!'),
});

export const validationTransferDomain = Yup.object().shape({
  targetGroupId: Yup.object().shape({
    value: Yup.string().required('Target group id is required field'),
  }),
  domainDeliveredThresholdTransfer: Yup.number()
    .typeError('Threshold must be integer number!')
    .integer('Threshold release must be integer number!')
    .min(0, 'Threshold release must be in range 0 <= number <= 99')
    .max(99, 'Threshold release must be in range 0 <= number <= 99')
    .required('Threshold release is required field!'),
});

export const validateOffer = Yup.object().shape({
  title: Yup.string()
    .required('Title is required field!')
    .max(200, 'Title is too long, need to less than 200 characters!'),
  domain: Yup.string().required('Domain is required field!').nullable(),
});

export const validationCreateContact = Yup.object().shape({
  groupName: Yup.string()
    .required('Please input a group name!')
    .matches(validNotSpecialCharacter, 'Must be _, -, space, number and letter!')
    .min(3, 'Please input 3 ~ 200 characters')
    .max(200, 'Please input 3 ~ 200 characters'),
});

export const validateRenameContact = Yup.object().shape({
  title: Yup.string()
    .required('Title is required field!')
    .matches(validNotSpecialCharacter, 'Must be _, -, space, number and letter!')
    .trim('Title is required field!')
    .min(3, 'Please input 3 ~ 200 characters')
    .max(200, 'Please input 3 ~ 200 characters'),
});

export const validateMoveDidSelected = Yup.object().shape({
  targetGroupId: Yup.object().shape({
    value: Yup.number()
      .typeError('Target Group Id is incorrect format number!')
      .required('Target Group Id is required field!'),
  }),
});

export const validateSchemaMoveDomain = Yup.object().shape({
  targetGroupId: Yup.string().required('Target group id is required field'),
});

export const validateSchemaReport = Yup.object().shape({
  title: Yup.string().required('Title is required field!').trim('Title is required field!'),
  description: Yup.string()
    .required('Description is required field!')
    .trim('Title is required field!'),
});

export const validateSchemaMigrateDomainGroup = Yup.object().shape({
  groupId: Yup.object().shape({
    value: Yup.string().required('Source group must be selected!'),
  }),
  targetGroupId: Yup.object().shape({
    value: Yup.string().required('Source group must be selected!'),
  }),
  amount: Yup.number()
    .integer('Amount must be integer number!')
    .min(1, 'Amount must be greater or equal than 1!')
    .when(['groupId', 'targetGroupId'], {
      is: (groupId, targetGroupId) => !!groupId && !!targetGroupId,
      then: Yup.number().required('Amount is required field!'),
    }),
});

export const validationCommonName = Yup.object().shape({
  name: Yup.string()
    .test('Trim', 'Name field is required', function () {
      const { name } = this.parent;
      if (name && name.trim()) {
        return true;
      }
      return false;
    })
    .required('Name field is required!')
    .max(200, 'Name is too long, need to less than 200 characters!'),
});

export const validationCommonTitle = Yup.object().shape({
  title: Yup.string()
    .test('Trim', 'Title field is required', function () {
      const { title } = this.parent;
      if (title && title.trim()) {
        return true;
      }
      return false;
    })
    .required('Title must required!')
    .max(200, 'Title is too long, need to less than 200 characters!'),
});

export const validateCreateResponder = Yup.object().shape({
  enableTemplate: Yup.boolean(),
  selected: Yup.string().required('Contact group must be selected!'),
  selectedTemplate: Yup.string().when('enableTemplate', {
    is: (el) => el,
    then: Yup.string().required('Responder template must be selected!'),
  }),
});

export const validationSchemaCampaignEdit = (variables) =>
  Yup.object().shape({
    responderOffers: Yup.array().of(
      Yup.object().shape({
        typeInput: Yup.string(),
        variable: Yup.string()
          .required('Variable is required field!')
          .matches(
            validMessageVariableRegExp,
            'Message variable is incorrect format! It must have square brackets. E.g: [custom-var]',
          )
          .test(
            'check-variable',
            'Message variable is duplicated with existing variable list of system!',
            function () {
              const { originalValue } = this.options;
              if (originalValue) {
                const variable = originalValue.toLowerCase();
                // check if value existed in variables
                if (variables.map((ele) => ele.toLowerCase()).some((ele) => ele === variable)) {
                  return false;
                }
              }
              return true;
            },
          ),
        offerId: Yup.string().when('typeInput', {
          is: (val) => val !== 'inputText',
          then: Yup.string().required('Offer must be selected!'),
        }),
        url: Yup.string().when('typeInput', {
          is: (val) => val === 'inputText',
          then: Yup.string()
            .required('Url is required field!')
            .matches(validDomain, 'URL is incorrect format!'),
        }),
        domain: Yup.string().when('typeInput', {
          is: (val) => val === 'inputText',
          then: Yup.string().required('Domain is required field!'),
        }),
      }),
    ),
  });

export const validationSchemaCampaign = (variables) =>
  Yup.object().shape({
    autoOp: Yup.boolean(),
    totalTarget: Yup.number().nullable(),
    impressionUrl: Yup.string().matches(validDomain, 'URL is incorrect format!'),
    fromPhone: Yup.string().required('Type phone is required!'),
    phone: Yup.string().required('Contact group is required!'),
    creativeIds: Yup.array()
      .when('creativeOnFly', {
        is: (val) => val && val.length <= 0,
        then: Yup.array().min(1, 'Select at least one creative!'),
      })
      .nullable(),
    creativeOnFly: Yup.array().of(
      Yup.object().shape({
        message: Yup.string().required('Message is required field!'),
      }),
    ),
    offerIds: Yup.array().when('offerOption', {
      is: (val) => val === stateOffer.OFFER,
      then: Yup.array().min(1, 'Select at least one offer!'),
    }),
    offerOnFly: Yup.array().when('offerOption', {
      is: (val) => val === stateOffer.OFFER,
      then: Yup.array().of(
        Yup.object().shape({
          url: Yup.string()
            .required('Url is required field!')
            .matches(validDomain, 'URL is incorrect format!'),
          domain: Yup.string().required('Domain is required field!'),
        }),
      ),
    }),
    domain: Yup.string().when(['offerOption', 'urlShortened'], {
      is: (offerOption, urlShortened) => urlShortened && offerOption === stateOffer.PREFILL_OFFER,
      then: Yup.string().required('Select at least one domain!'),
    }),
    responderAdvanceSetting: Yup.array().of(
      Yup.object().shape({
        typeInput: Yup.string(),
        variable: Yup.string()
          .required('Variable is required field!')
          .matches(
            validMessageVariableRegExp,
            'Message variable is incorrect format! It must have square brackets. E.g: [custom-var]',
          )
          .test(
            'check-variable',
            'Message variable is duplicated with existing variable list of system!',
            function () {
              const { originalValue } = this.options;
              if (originalValue) {
                const variable = originalValue.toLowerCase();
                // check if value existed in variables
                if (variables.map((ele) => ele.toLowerCase()).some((ele) => ele === variable)) {
                  return false;
                }
              }
              return true;
            },
          ),
        offerId: Yup.string().when('typeInput', {
          is: (val) => val !== 'inputText',
          then: Yup.string().required('Offer must be selected!'),
        }),
        url: Yup.string().when('typeInput', {
          is: (val) => val === 'inputText',
          then: Yup.string()
            .required('Url is required field!')
            .matches(validDomain, 'URL is incorrect format!'),
        }),
        domain: Yup.string().when('typeInput', {
          is: (val) => val === 'inputText',
          then: Yup.string().required('Domain is required field!'),
        }),
      }),
    ),
    testSize: Yup.number()
      .transform(emptyStringToNull)
      .nullable()
      .when(['totalTarget', 'autoOp'], {
        is: (totalTarget, autoOp) =>
          !!toString(totalTarget) && Number(totalTarget) > minContactToOptimization && autoOp,
        then: Yup.number()
          .integer('Test size must be integer number!')
          .required('Test size is required field!')
          .test('check_range', 'Range', function () {
            const { path } = this;
            const { testSize, totalTarget = 0 } = this.parent;
            if (!!toString(testSize)) {
              if (testSize <= minContactToOptimization || testSize >= totalTarget) {
                return this.createError({
                  path,
                  message: `Test size must be in range ${minContactToOptimization} < number < ${totalTarget}`,
                });
              }
            }

            return true;
          }),
      }),
    pausedMin: Yup.number()
      .transform(emptyStringToNull)
      .nullable()
      .when(['totalTarget', 'autoOp'], {
        is: (totalTarget, autoOp) =>
          !!toString(totalTarget) && Number(totalTarget) > minContactToOptimization && autoOp,
        then: Yup.number()
          .required('Paused time size is required field!')
          .integer('Paused time size must be integer number!')
          .min(
            minPausedMinOptimization,
            `Paused time must be in range ${
              minPausedMinOptimization - 1
            } < number < ${maxPausedMinOptimization}`,
          )
          .max(
            maxPausedMinOptimization - 1,
            `Paused time must be in range ${
              minPausedMinOptimization - 1
            } < number < ${maxPausedMinOptimization}`,
          ),
      }),
    threshold: Yup.number()
      .transform(emptyStringToNull)
      .nullable()
      .when(['totalTarget', 'autoOp'], {
        is: (totalTarget, autoOp) =>
          !!toString(totalTarget) && Number(totalTarget) > minContactToOptimization && autoOp,
        then: Yup.number()
          .required('Minimum threshold is required field!')
          .integer('Minimum threshold must be integer number!')
          .min(1, 'Minimum threshold must be in range 0 < number < 100')
          .max(99, 'Minimum threshold must be in range 0 < number < 100'),
      }),
    autoOpLap2CreativeSize: Yup.number()
      .transform(emptyStringToNull)
      .nullable()
      .when(['totalTarget', 'autoOpLap2'], {
        is: (totalTarget, autoOpLap2) =>
          !!toString(totalTarget) && Number(totalTarget) > minContactToOptimization && autoOpLap2,
        then: Yup.number()
          .required('Amount is required field!')
          .integer('Amount must be integer number!')
          .test('check_amount', 'message check amount creative size', function () {
            const { path } = this;
            const { autoOpLap2CreativeSize = 0, creativeIds = [] } = this.parent;

            const numberOfCreative = (creativeIds || []).length;

            if (!numberOfCreative) {
              return this.createError({
                path,
                message: `Select at least one creative`,
              });
            }

            if (autoOpLap2CreativeSize <= 0 || autoOpLap2CreativeSize > numberOfCreative) {
              return this.createError({
                path,
                message: `Amount must be in range 0 < number <= ${numberOfCreative}`,
              });
            }

            return true;
          }),
      }),
    testSizeLap2: Yup.number()
      .transform(emptyStringToNull)
      .nullable()
      .when(['totalTarget', 'autoOpLap2'], {
        is: (totalTarget, autoOpLap2) =>
          !!toString(totalTarget) && Number(totalTarget) > minContactToOptimization && autoOpLap2,
        then: Yup.number()
          .integer('Test size lap 2 must be integer number!')
          .required('Test size lap 2 is required field!')
          .test('check_range', 'Range', function () {
            const { path } = this;
            const { testSizeLap2, totalTarget = 0 } = this.parent;
            if (!!toString(testSizeLap2)) {
              if (testSizeLap2 <= minContactToOptimization || testSizeLap2 >= totalTarget) {
                return this.createError({
                  path,
                  message: `Test size lap 2 must be in range ${minContactToOptimization} < number < ${totalTarget}`,
                });
              }
            }

            return true;
          }),
      }),
    pausedMinLap2: Yup.number()
      .transform(emptyStringToNull)
      .nullable()
      .when(['totalTarget', 'autoOpLap2'], {
        is: (totalTarget, autoOpLap2) =>
          !!toString(totalTarget) && Number(totalTarget) > minContactToOptimization && autoOpLap2,
        then: Yup.number()
          .required('Paused time lap 2 size is required field!')
          .integer('Paused time lap 2 size must be integer number!')
          .min(10, 'Paused time lap 2 must be in range 9 < number < 2400')
          .max(2399, 'Paused time lap 2 must be in range 9 < number < 2400'),
      }),
    thresholdLap2: Yup.number()
      .transform(emptyStringToNull)
      .nullable()
      .when(['totalTarget', 'autoOpLap2'], {
        is: (totalTarget, autoOpLap2) =>
          !!toString(totalTarget) && Number(totalTarget) > minContactToOptimization && autoOpLap2,
        then: Yup.number()
          .required('Minimum threshold lap 2 is required field!')
          .integer('Minimum threshold lap 2 must be integer number!')
          .min(1, 'Minimum threshold lap 2 must be in range 0 < number < 100')
          .max(99, 'Minimum threshold lap 2 must be in range 0 < number < 100'),
      }),
  });

const validationResponderDetail = Yup.object().shape({
  creativeOnFly: Yup.array().of(
    Yup.object().shape({
      message: Yup.string().required('Message is required field!'),
      delayedTime: Yup.number()
        .integer('Delayed time must be integer number!')
        .min(0, 'Delayed time must be greater or equal than 0!')
        .required('Delayed time is required field!'),
    }),
  ),
  creativeIds: Yup.array().when('creativeOnFly', {
    is: (val) => val && val.length <= 0,
    then: Yup.array()
      .of(
        Yup.object().shape({
          delayedTime: Yup.number()
            .typeError('Delayed time must be integer number!')
            // .integer('Delayed time must be integer number!')
            .min(0, 'Delayed time must be greater or equal than 0!')
            .test('limitDecimal', 'Limit 3 decimals', function () {
              const { parent } = this;
              const { delayedTime = 0 } = parent;
              return checkLimitDecimal(delayedTime, 3);
            })
            .nullable(),
          offerOption: Yup.string(),

          offerOnFly: Yup.array().of(
            Yup.object().shape({
              domain: Yup.string().required('Domain is required field'),
              url: Yup.string()
                .required('Url is required field')
                .matches(validDomain, 'URL is incorrect format!'),
            }),
          ),

          offers: Yup.array().when('offerOption', {
            is: (val) => val === stateOffer.OFFER,
            then: Yup.array().min(1, 'Select at least 1 offer!'),
          }),

          domain: Yup.string()
            .when(['offerOption', 'urlShortened'], {
              is: (offerOption, urlShortened) => {
                return offerOption === stateOffer.PREFILL_OFFER && urlShortened;
              },
              then: Yup.string().required('Select at least 1 domain!'),
            })
            .nullable(),
        }),
      )
      .required('Creatives must not be empty!'),
  }),
  impressionUrl: Yup.string().matches(validDomain, 'URL is incorrect format!').trim(),
});

export const validationNotificationSettingSchema = Yup.object().shape({
  notiEmailAddress: Yup.string()
    .test('EmailValidateCustom', 'Email is incorrect format!', function () {
      const { notiEmailAddress } = this.parent;
      if (notiEmailAddress && notiEmailAddress.trim()) {
        if (validEmail.test(notiEmailAddress.trim())) {
          return true;
        }
      }
      return false;
    })
    .required('Email is required field!'),
});

const validationSettingsSchema = Yup.object().shape({
  myAccountFirstname: Yup.string()
    .test('DetectTrim', 'First name is required field!', function () {
      const { myAccountFirstname } = this.parent;
      if (myAccountFirstname && myAccountFirstname.trim()) {
        return true;
      }
      return false;
    })
    .required('First name is required field!'),

  myAccountLastname: Yup.string()
    .test('DetectTrim', 'Last name is required field!', function () {
      const { myAccountLastname } = this.parent;
      if (myAccountLastname && myAccountLastname.trim()) {
        return true;
      }
      return false;
    })
    .required('Last name is required field!'),

  inputDomain: Yup.string().when('prefillOfferEnable', {
    is: (val) => val,
    then: Yup.string()
      .matches(validDomain, 'URL is incorrect format!')
      .required('Input domain is required field!'),
  }),

  params: Yup.array().when('prefillOfferEnable', {
    is: (val) => val,
    then: Yup.array()
      .of(
        Yup.object().shape({
          param: Yup.string()
            .matches(onlyLettersAndNumber, 'Invalid param!')
            .required('Param must be filled!'),
          value: Yup.string().required('Value param must be filled'),
        }),
      )
      .required('You need add at least one param!'),
  }),

  paramsFullfill: Yup.array().when('fullfillOfferEnable', {
    is: (val) => val,
    then: Yup.array()
      .of(
        Yup.object().shape({
          param: Yup.string()
            .matches(onlyLettersAndNumber, 'Invalid param!')
            .required('Param must be filled!'),
          value: Yup.string().required('Value param must be filled'),
        }),
      )
      .required('You need add at least one param!'),
  }),
  autoOpTestSizeLap1: Yup.number()
    .transform(emptyStringToNull)
    .nullable()
    .when(['autoOpActive'], {
      is: (autoOp) => autoOp,
      then: Yup.number()
        .integer('Test size must be integer number!')
        .required('Test size is required field!'),
    }),
  autoOpPausedMinLap1: Yup.number()
    .transform(emptyStringToNull)
    .nullable()
    .when(['autoOpActive'], {
      is: (autoOp) => autoOp,
      then: Yup.number()
        .required('Paused time size is required field!')
        .integer('Paused time size must be integer number!')
        .min(
          10,
          `Paused time must be in range ${
            minPausedMinOptimization - 1
          } < number < ${maxPausedMinOptimization}`,
        )
        .max(
          maxPausedMinOptimization - 1,
          `Paused time must be in range ${
            minPausedMinOptimization - 1
          } < number < ${maxPausedMinOptimization}`,
        ),
    }),
  autoOpThresholdLap1: Yup.number()
    .transform(emptyStringToNull)
    .nullable()
    .when(['autoOpActive'], {
      is: (autoOp) => autoOp,
      then: Yup.number()
        .required('Minimum threshold is required field!')
        .integer('Minimum threshold must be integer number!')
        .min(1, 'Minimum threshold must be in range 0 < number < 100')
        .max(99, 'Minimum threshold must be in range 0 < number < 100'),
    }),
  autoOpLap2CreativeSize: Yup.number()
    .transform(emptyStringToNull)
    .nullable()
    .when(['autoOpLap2Active'], {
      is: (autoOp) => autoOp,
      then: Yup.number()
        .required('Amount is required field!')
        .integer('Amount must be integer number!')
        .min(1, 'Amount must be equal or larger than 1!'),
    }),
  autoOpTestSizeLap2: Yup.number()
    .transform(emptyStringToNull)
    .nullable()
    .when(['autoOpLap2Active'], {
      is: (autoOpLap2) => autoOpLap2,
      then: Yup.number()
        .integer('Test size lap 2 must be integer number!')
        .required('Test size lap 2 is required field!'),
    }),
  autoOpPausedMinLap2: Yup.number()
    .transform(emptyStringToNull)
    .nullable()
    .when(['autoOpLap2Active'], {
      is: (autoOpLap2) => autoOpLap2,
      then: Yup.number()
        .required('Paused time lap 2 size is required field!')
        .integer('Paused time lap 2 size must be integer number!')
        .min(10, 'Paused time lap 2 must be in range 9 < number < 2400')
        .max(2399, 'Paused time lap 2 must be in range 9 < number < 2400'),
    }),
  autoOpThresholdLap2: Yup.number()
    .transform(emptyStringToNull)
    .nullable()
    .when(['autoOpLap2Active'], {
      is: (autoOpLap2) => autoOpLap2,
      then: Yup.number()
        .required('Minimum threshold lap 2 is required field!')
        .integer('Minimum threshold lap 2 must be integer number!')
        .min(1, 'Minimum threshold lap 2 must be in range 0 < number < 100')
        .max(99, 'Minimum threshold lap 2 must be in range 0 < number < 100'),
    }),
});

const validationUsersSchema = Yup.object().shape({
  id: Yup.mixed(),
  email: emailYupCheck,
  firstname: Yup.string()
    .test('DetectTrim', 'First name is required field!', function () {
      const { firstname } = this.parent;
      if (firstname && firstname.trim()) {
        return true;
      }
      return false;
    })
    .required('First name is required field!'),
  lastname: Yup.string()
    .test('DetectTrim', 'Last name is required field!', function () {
      const { lastname } = this.parent;
      if (lastname && lastname.trim()) {
        return true;
      }
      return false;
    })
    .required('Last name is required field!'),
  phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
  //* TA-3862
  // agentAcc: Yup.string().test(
  //   'EmailValidateCustom',
  //   "Agent's email is incorrect format!",
  //   function() {
  //     const { agentAcc } = this.parent;
  //     if (agentAcc && agentAcc.trim()) {
  //       if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(agentAcc.trim())) {
  //         return false;
  //       }
  //     }
  //     return true;
  //   }
  // ),
  // billingAddress: Yup.string().required(REQUIRED_FIELD('Billing Address')),
  // billingName: Yup.string().required(REQUIRED_FIELD('Billing Name')),
  // billingCountry: Yup.string().required(REQUIRED_FIELD('Billing Country')),
  // billingRegNo: Yup.string().required(REQUIRED_FIELD('Billing Reg No')),
  // billingVatNo: Yup.string().required(REQUIRED_FIELD('Billing VAT No')),

  enableRndScrub: Yup.boolean(),
  rndScrubCarriers: Yup.string().when(['enableRndScrub'], {
    is: (val) => !!val,
    then: validateTrimAndRequiredString('Rnd Scrub Carriers'),
  }),
  rndScrubStartDate: Yup.string()
    .when(['enableRndScrub'], {
      is: (val) => !!val,
      then: validateTrimAndRequiredString('Start Date'),
    })
    .nullable(),

  roles: validateTrimAndRequiredString('Roles'),
  country: Yup.string().required('Country is required field!'),
  statusName: Yup.string().required('Status is required field!'),
  timeName: Yup.string().required('Time Zone is required field!'),
  apiRateLimit: Yup.number()
    .typeError('Rate limit must be number!')
    .integer('Rate limit must be integer number!')
    .min(0, 'Rate limit must be >= 0!'),
  // routes: Yup.array().min(1, REQUIRED_FIELD('Routes')),

  // speed: Yup.number()
  //   .typeError('Send speed must be number!')
  //   .integer('Send speed must be integer number!')
  //   .min(0, 'Send speed must be >= 0!'),
  // limitNumberMessagePerDay: Yup.number().when('twoWay', {
  //   is: (value) => value === '2' || value === 2,
  //   then: Yup.number()
  //     .typeError('Limit number message per day must be integer number!')
  //     .integer('Limit number message per day must be integer number!')
  //     .required('Limit number is required field and in range [100 - 30,000]!')
  //     .min(100, 'Limit number must be in range [100 - 30,000]!')
  //     .max(30000, 'Limit number must be in range [100 - 30,000]!'),
  // }),

  //* If isEdit -> Not validate subscription
  // subscriptionPlanId: Yup.string().when(['id'], {
  //   is: (id) => !isDefine(id),
  //   then: validateTrimAndRequiredString('Subscription Plan'),
  // }),
  // monthlyPeriod: Yup.string().when(['id'], {
  //   is: (id) => !isDefine(id),
  //   then: validateTrimAndRequiredString('monthlyPeriod'),
  // }),
});

const validationDateTimeExportDetail = Yup.object().shape({
  fromDate: Yup.date()
    .test('compareDate', 'From Date must be earlier than To Date!', function () {
      const { fromDate, toDate } = this.parent;
      return fromDate && toDate && moment(fromDate) <= moment(toDate);
    })
    .required('From Date is required field!'),
  toDate: Yup.date().required('To Date is required field!'),
});

const validationDateTimeCampaign = Yup.object().shape({
  lastSentDate: Yup.date().required('Last sent date is required field!'),
});

const validationPayment = Yup.object().shape({
  numberRecharge: Yup.number().test(
    'check-invalid-number',
    'Input has the minimum is 500 and the maximum 10000',
    function () {
      const { numberRecharge, autoRecharge } = this.parent;
      if (autoRecharge) {
        if (
          isDefine(numberRecharge) &&
          (Number(numberRecharge) < 500 || Number(numberRecharge) > 10000)
        ) {
          return false;
        }
      }
      return true;
    },
  ),
});
const validationPaymentCreate = Yup.object().shape({
  email: Yup.string()
    .test('EmailValidateCustom', 'Email is incorrect format!', function () {
      const { email } = this.parent;
      if (email && email.trim()) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email.trim())) {
          return true;
        }
      }
      return false;
    })
    .test('check-trim', 'Email is required field!', function () {
      const { email } = this.parent;
      if (email) {
        if (email.trim() === '') return false;
      }
      return true;
    })
    .required('Email is required field!'),

  phone: Yup.string()
    .test('check-trim', 'Phone number is required field!', function () {
      const { phone } = this.parent;
      if (phone) {
        if (phone.trim() === '') return false;
      }
      return true;
    })
    .matches(phoneRegExp, 'Phone number is not valid')
    .required('Phone number is required field!'),

  name: Yup.string()
    .test('check-trim', 'Name is required field!', function () {
      const { name } = this.parent;
      if (name) {
        if (name.trim() === '') return false;
      }
      return true;
    })
    .required('Name is required field!'),

  postal_code: Yup.string()
    .test('check-trim', 'Zip code is required field!', function () {
      const { postal_code } = this.parent;
      if (postal_code) {
        if (postal_code.trim() === '') return false;
      }
      return true;
    })
    .required('Zip code is required field!'),
});

const validationAutomationTest = Yup.object().shape({
  name: Yup.string().required('Test name is required field!'),
  code: Yup.string().required('Test code is required field!'),
  message: Yup.string().required('Message is required field!'),
  messageType: Yup.string().required('Message type is required field!'),

  voiceId: Yup.mixed().when(['messageType'], {
    is: (messageType) => messageType === 'VOICE',
    then: Yup.mixed().test('required', REQUIRED_FIELD('Voice'), testSchema.isRequired('voiceId')),
  }),
});

const validationSplitGroup = Yup.object().shape({
  size: Yup.number().min(100, 'Size must be larger than 100!'),
});

const validationAddDomain = Yup.object().shape({
  domains: Yup.array().of(
    Yup.string()
      .matches(validDomain, 'Incorrect domain format!')
      .test('check-duplicate-domain', 'Check Domain', function () {
        const { path, parent } = this;
        if (parent) {
          // Check require field
          const listDomains = trimListString([...parent]);
          if (
            !this.options.originalValue ||
            (typeof this.options.originalValue === 'string' &&
              this.options.originalValue.trim() === '')
          ) {
            return this.createError({
              path,
              message: 'The domain input is required field!',
            });
          }

          // Check duplicate
          if (hasDuplicateItem(listDomains)) {
            const listItemDuplicate = filterDuplicateItem(listDomains);
            if (listItemDuplicate.includes(this.options.originalValue.trim())) {
              return this.createError({
                path,
                message: 'Duplicate domain - please check again!',
              });
            }
          }

          // Check delimeter in list domain
          if (listDomains) {
            for (let i = 0; i < listDelimiter.length; i++) {
              const valueTrimAndRemoveSpace = this.options.originalValue.trim().replace(/ /g, '');
              if (valueTrimAndRemoveSpace.includes(listDelimiter[i])) {
                if (valueTrimAndRemoveSpace.split(listDelimiter[i]).length > 1) {
                  return this.createError({
                    path,
                    message: 'Incorrect domain format!',
                  });
                }
              }
            }
          }

          // Check Vietnamese
          if (
            /[\u0300-\u036fđĐ]/.test(
              this.options.originalValue.trim().replace(/ /g, '').normalize('NFD'),
            )
          ) {
            return this.createError({
              path,
              message: 'Incorrect domain format!',
            });
          }
        }
        return true;
      })
      .required('The domain input is required field!'),
  ),
});

const validationAddBulkDomain = Yup.object().shape({
  domains: Yup.string()
    .test('check-valid-domain', 'List of domain is incorrect format!', function () {
      const { domains } = this.parent;
      // Check if all delimiter appear together
      if (checkAllDelimiterAppearTogether(listDelimiter, domains)) {
        return false;
      }
      return true;
    })
    .test('check-domain-add-bulk', 'Some domain in list is incorrect format!', function () {
      const { domains } = this.parent;
      if (domains && typeof domains === 'string') {
        const checkValidDomainWithDelimeter = (delimeter) => {
          const listDomainsAfterConvert = domains.split(delimeter);
          let isValidDomain = true;
          listDomainsAfterConvert
            .filter((el) => el)
            .forEach((domain) => {
              if (!validDomain.test(domain.trim())) {
                isValidDomain = false;
              } else if (
                /[\u0300-\u036fđĐ]/.test(domain.trim().replace(/ /g, '').normalize('NFD'))
              ) {
                isValidDomain = false;
              }
            });

          return isValidDomain;
        };

        let isPass = true;
        // Check it with each delimiter
        listDelimiter.forEach((d) => {
          if (checkValidDomainWithDelimeter(d) === false) {
            isPass = false;
          }
        });

        return isPass;
      }
    })
    .required('The domain input is required field!'),
});

const validationSearchDomain = Yup.object().shape({
  price_from: Yup.number()
    .typeError('Price from must be a number')
    .test('check-larger-than-price-to', 'Price From must be smaller than Price To!', function () {
      const { price_from, price_to } = this.parent;
      if (price_from && price_to) {
        if (!Number.isNaN(Number(price_from))) {
          if (!Number.isNaN(Number(price_to))) {
            if (Number(price_from) > Number(price_to)) return false;
          }
        }
      }
      return true;
    })
    .required('Price from is required field!'),
  price_to: Yup.number()
    .typeError('Price to must be a number')
    .required('Price to is required field!'),
  quantity: Yup.number()
    .typeError('Quantity must be a number')
    .required('Quantity is required field!'),
});

const validationAddDidUserDetailSchema = Yup.object().shape({
  phone: Yup.string()
    .required('Phone is required field!')
    .test('check-valid-phone', 'List of phone number is incorrect format!', function () {
      const { phone } = this.parent;
      // Check if all delimiter appear together
      if (phone) {
        if (checkAllDelimiterAppearTogether(listDelimiter, phone)) {
          return false;
        }
        return true;
      }
      return true;
    })
    .test('check-valid', 'Phone in list is incorrect format!', function () {
      const { phone } = this.parent;
      if (phone && typeof phone === 'string') {
        let isPass = false;
        listDelimiter.forEach((delimiter) => {
          if (phone.includes(delimiter)) {
            const checkValidPhoneWithDelimeter = (delimiter) => {
              const listPhoneAfterConvert = phone.split(delimiter);
              let isValidPhone = true;
              listPhoneAfterConvert
                .filter((el) => el)
                .forEach((p) => {
                  if (!phoneRegExp.test(p.trim())) {
                    isValidPhone = false;
                  }
                });
              return isValidPhone;
            };
            isPass = checkValidPhoneWithDelimeter(delimiter);
          }
        });
        return isPass;
      }
      return true;
    }),
});

const validateGetMessageStats = Yup.object().shape({
  from: Yup.date()
    .typeError('From Date is required field!')
    .test('compareDate', 'From Date must be earlier than To Date!', function () {
      const { from, to } = this.parent;
      return from && to && moment(from) <= moment(to);
    })
    .required('From Date is required field!'),

  to: Yup.date().typeError('To Date is required field!').required('To Date is required field!'),
});

const validateSearchNumberPool = Yup.object().shape({
  vendorId: Yup.string().required('Vendor is required field!'),
  countryCode: Yup.string().required('Country Code is required field!'),
});

export const validateAmountCredit = Yup.number()
  .moreThan(0, 'Amount must be larger than 0!')
  .required(REQUIRED_FIELD('Amount credits'));
export const validateEmail = Yup.string().test(
  'EmailValidateCustom',
  'Email is incorrect format!',
  function (value) {
    if (value && value.trim()) {
      if (validEmail.test(value.trim())) {
        return true;
      }
    }
    return false;
  },
);

export const validateMediaWithConfigs = ({ isSelectMultiMedia } = {}) =>
  Yup.object().shape({
    useConfigAudio: Yup.boolean(),
    enableMediaGroup: Yup.boolean(),
    mediaGroupId: Yup.mixed().when(['useConfigAudio', 'enableMediaGroup'], {
      is: (useConfigAudio, enableMediaGroup) => useConfigAudio && enableMediaGroup,
      then: Yup.mixed().test('required', REQUIRED_FIELD('Media group'), function (mediaGroup) {
        if (!mediaGroup) {
          return false;
        }

        return true;
      }),
    }),
    mainAudioId: Yup.mixed().when(['useConfigAudio', 'enableMediaGroup'], {
      is: (useConfigAudio, enableMediaGroup) => useConfigAudio && !enableMediaGroup,
      then: Yup.mixed().test('required', REQUIRED_FIELD('Main audio'), function (mainAudio) {
        if (!mainAudio) {
          return false;
        }

        return true;
      }),
    }),
    media: Yup.mixed().when(['useConfigAudio'], {
      is: (useConfigAudio) => !useConfigAudio,
      then: isSelectMultiMedia
        ? Yup.mixed().test('required', REQUIRED_FIELD('Media'), function (media) {
            if (!media || (isArray(media) && media.length <= 0)) {
              return false;
            }

            return true;
          })
        : Yup.mixed().test('required', REQUIRED_FIELD('Media'), function (media) {
            if (!media) {
              return false;
            }

            return true;
          }),
    }),
  });

export {
  validationResponderDetail,
  validateGetMessageStats,
  validationAddDidUserDetailSchema,
  validationAddBulkDomain,
  validationSearchDomain,
  validationSplitGroup,
  validationPaymentCreate,
  validationPayment,
  validationAutomationTest,
  validationSettingsSchema,
  validationUsersSchema,
  maxLengthName,
  commonInputMaxLength,
  validationDateTimeExportDetail,
  validationDateTimeCampaign,
  validationAddDomain,
  validateSearchNumberPool,
};
